import { createStandardAction } from 'typesafe-actions';
export var GOOGLE_API_INITIALIZED = 'GOOGLE_API_INITIALIZED';
export var googleApiInitialized = createStandardAction(GOOGLE_API_INITIALIZED)();